import { Field } from "@progress/kendo-react-form";
import { ConfigWorkflow } from "./ConfigurationEnums";
import { FormRadioGroup } from "../../form";
import { requiredValidator } from "../../../validators";

interface IConfigurationsStartStepProps {
  onWorkflowChange: (workflow: string) => void;
}

export const ConfigurationsStartStep = ({ onWorkflowChange }: IConfigurationsStartStepProps) => {
  const items: any[] = [
    {
      label: "Products",
      value: ConfigWorkflow.Products,
      description: [
        "Assign products + margins to multiple companies",
        "Suspend or reactivate products for multiple companies",
      ],
    },
    {
      label: "Company",
      value: ConfigWorkflow.Companies,
      description: [
        "Assign products + margins to a specific company",
        "Copy one company's products + margins to another company",
        "Suspend or reactivate products for a specific company",
      ],
    },
    {
      label: "Margin",
      value: ConfigWorkflow.Margins,
      description: ["Assign a specific margin to multiple products for multiple companies"],
    },
  ];

  const radioButtonData = items.map((item) => {
    return {
      ...item,
      children:
        item.description?.length > 0 ? (
          <div key={item.label}>
            {item.description.map((d: string) => (<span className="k-form-hint">{d}</span>))}
          </div>
        ) : undefined,
    };
  });

  return (
    <div className="stepper-form" style={{ display: "flex", justifyContent: "center" }}>
      <Field
        label={"Select the type of bulk operation workflow:"}
        key={"workflow"}
        id={"workflow"}
        name={"workflow"}
        component={FormRadioGroup}
        validator={requiredValidator}
        data={radioButtonData}
        className="radio-group-with-children"
        onChange={(e) => onWorkflowChange(e.value)}
      />
    </div>
  );
};
